/* ---------------------------------------------------------------------------
監理種別
---------------------------------------------------------------------------- */
export const mgmt_type = {
	1: "一般監理団体",
	2: "特定監理団体",
	3: "その他"
};

export const typeEnum = {
	1: "技能",
	2: "特定"
};

export const category = {
	1: "法人",
	2: "個人"
};
export const status = {
	1: "成約済",
	2: "解約済",
	3: "商談済",
	4: "過去成約(無料期間のみ)"
};
export const call_result = {
	1: "不通",
	2: "担当者不在(話ができていない)",
	3: "見込み",
	4: "見込みなし",
	5: "アポ確",
	6: "現アナ",
	7: "対象外"
};
export const estimate = {
	1: "ありA(アポは取れる)",
	2: "ありB(あと一歩でアポ取れる)",
	3: "ありC(頑張ればアポ取れる)",
	4: "資料送付(11月)",
	5: "資料送付(3月)",
	6: "特定技能実装後",
	7: "アップデート後",
	8: "特定職種の対応後"
};
export const no_estimate = {
	1: "ガチャ切り",
	2: "受付お断り",
	3: "担当お断り",
	4: "断り(理由あり)",
	5: "断り(理由聞けず)"
};
export const post_meeting_status = {
	1: "検討中",
	2: "担当者不在続き",
	3: "忙しくて検討できておらず",
	4: "受け入れがまだできていない",
	5: "機能面で他者に決めてNG",
	6: "Zoom参加者以外のNG",
	7: "人数が少ないためNG",
	8: "日を改めて再検討"
};
export const management_method = {
	1: "Excel",
	2: "チャイナくん",
	3: "dekisugi",
	4: "JITCO",
	5: "その他",
	6: "教えてくれない",
	7: "何処かのシステム",
	8: "g-worker"
};
export const isOrIsnt = {
	1: "有",
	2: "無"
};
export const usage_status = {
	1: "無料お試し中",
	2: "有料継続中",
	3: "解約",
	4: "支払方法登録前",
	5: "メール認証前"
};
export const cancellation_reason = {
	1: "書類作成機能がない"
};

export const country = {
	1: "インド",
	2: "インドネシア",
	3: "ウズベキスタン",
	4: "カンボジア",
	5: "スリランカ",
	6: "タイ",
	7: "中国",
	8: "ネパール",
	9: "パキスタン",
	10: "バングラデシュ",
	11: "フィリピン",
	12: "ブータン",
	13: "ベトナム",
	14: "ミャンマー",
	15: "モンゴル",
	16: "ラオス"
};
